export const CANVAS_CHANGED = 'CANVAS_CHANGED';

export const CANVAS_DONE = 'CANVAS_DONE';

export const SIGN_IN = 'SIGN_IN';

export const SIGN_OUT = 'SIGN_OUT';

export const FETCH_ORDERS = 'FETCH_ORDERS';

export const FETCH_CANVAS_OBJECT = 'FETCH_CANVAS_OBJECT';

export const ADD_PHOTO = 'ADD_PHOTO';

export const ADD_CANVAS_OBJECT = 'ADD_CANVAS_OBJECT';

export const UPDATE_SELECTED_OBJECT = 'UPDATE_SELECTED_OBJECT';
